import { Component, EventEmitter, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ArtifactPreviewItem, DEOAiAssistantService } from '../../../services/deo-ai-assistant.service';

@Component({
  selector: 'deo-view-artifact-drawer',
  standalone: false,
  templateUrl: './deo-view-artifact-drawer.component.html',
  styleUrls: ['./deo-view-artifact-drawer.component.scss']
})
export class DeoViewArtifactDrawerComponent {
  @Output() drawerClosed = new EventEmitter<void>();

  constructor(private readonly _deoAiAssistantService: DEOAiAssistantService) {}

  get isArtifactDrawerVisible(): boolean {
    return this._deoAiAssistantService.isArtifactDrawerVisible;
  }

  get selectedArtifact(): ArtifactPreviewItem | null {
    return this._deoAiAssistantService.selectedArtifact;
  }

  get artifactView(): 'code' | 'preview' {
    return this._deoAiAssistantService.artifactView;
  }

  get safeArtifactHtml(): SafeHtml | null {
    return this._deoAiAssistantService.safeArtifactHtml;
  }

  changeArtifactView(view: 'code' | 'preview'): void {
    this._deoAiAssistantService.changeArtifactView(view);
  }

  downloadSelectedArtifact(): void {
    if (!this.selectedArtifact?.htmlContent) {
      return;
    }

    this._deoAiAssistantService.downloadArtifactContent(this.selectedArtifact.title, this.selectedArtifact.htmlContent, this.selectedArtifact.type);
  }

  closeDrawer(): void {
    this._deoAiAssistantService.closeArtifactPreview();
    this.drawerClosed.emit();
  }
}
